import { getPrevailingShapeType } from '../components/overlay/utils/get-prevailing-shape-type.js';
import type {
  HoverQuery,
  HoverQueryArgs,
  HoverQueryResult,
  QueryClosest,
  QueryHovered,
} from '../context/XYChartOverlayPerformance.context.js';

/**
 * Build the single-datapoint hover query.
 *
 * Runs closest-point queries on continuous series (dot/line/area) and
 * hovered queries on geometric series (rect/bar), then picks the
 * prevailing shape under the cursor.
 */
export function buildQuerySingle(
  queryClosest: QueryClosest,
  queryHovered: QueryHovered,
): HoverQuery {
  return function querySingle({
    position,
    dotSeriesData,
    lineSeriesData,
    areaSeriesData,
    rectSeriesData,
    barSeriesData,
  }: HoverQueryArgs): HoverQueryResult {
    const relative = position.relative;
    const results = {
      dot: queryClosest(dotSeriesData, relative),
      line: queryClosest(lineSeriesData, relative),
      area: queryClosest(areaSeriesData, relative),
      rect: queryHovered(rectSeriesData, relative),
      bar: queryHovered(barSeriesData, relative),
    };

    const prevailingShape = getPrevailingShapeType(
      results.dot?.distance,
      results.line?.distance,
      results.area?.distance,
      !!results.rect,
      !!results.bar,
    );

    if (!prevailingShape || !results[prevailingShape]) {
      return { preferred: undefined, datapoints: [] };
    }

    const preferred = results[prevailingShape];
    return { preferred, datapoints: [preferred] };
  };
}
